// https://www.deepl.com/docs-api/translate-text
export const DeeplLanguagesAll = [
    { code: 'bg', name: 'Bulgarian' },
    { code: 'cs', name: 'Czech' },
    { code: 'da', name: 'Danish' },
    { code: 'de', name: 'German' },
    { code: 'el', name: 'Greek' },
    {
        code: 'en',
        name: 'English (unspecified variant for backward compatibility; please select EN-GB or EN-US instead)',
    },
    { code: 'en-gb', name: 'English (British)' },
    { code: 'en-us', name: 'English (American)' },
    { code: 'es', name: 'Spanish' },
    { code: 'et', name: 'Estonian' },
    { code: 'fi', name: 'Finnish' },
    { code: 'fr', name: 'French' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'id', name: 'Indonesian' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'lt', name: 'Lithuanian' },
    { code: 'lv', name: 'Latvian' },
    { code: 'nb', name: 'Norwegian (Bokmål)' },
    { code: 'nl', name: 'Dutch' },
    { code: 'pl', name: 'Polish' },
    {
        code: 'pt',
        name: 'Portuguese (unspecified variant for backward compatibility; please select PT-BR or PT-PT instead)',
    },
    { code: 'pt-br', name: 'Portuguese (Brazilian)' },
    { code: 'pt-pt', name: 'Portuguese (all Portuguese varieties excluding Brazilian Portuguese)' },
    { code: 'ro', name: 'Romanian' },
    { code: 'ru', name: 'Russian' },
    { code: 'sk', name: 'Slovak' },
    { code: 'sl', name: 'Slovenian' },
    { code: 'sv', name: 'Swedish' },
    { code: 'tr', name: 'Turkish' },
    { code: 'uk', name: 'Ukrainian' },
    { code: 'zh', name: 'Chinese (simplified)' },
];
